// vim: set ts=2 sw=2 et tw=72 ft=javascript:
/**
 * Copyright (C) 2015 Minted Inc.
 *
 * All Rights Reserved
 *
 * CTAG:COMMUNITY
 */

var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/backbone-1.0.0.min': 'Backbone',
  'minted:vendor/jquery-1.9.1.min': '$',
  'minted:vendor/underscore-1.8.2.min': '_',
  'templito:community/util': [],
  'minted:vendor/jquery_ui/jquery-ui-1.10.3.custom': []
})(this, function (m_module, Backbone, $, _) {

  "use strict";

  var M = m_module.M;
  M.Community.View = M.Community.View || {};
  M.Community.View.Util = M.Community.View.Util || {};

  /**
   * @class M.Community.View.Util.ShowHide
   *
   * This class creates a 'Show more' widget for containers.
   * It hides all but a certain number of elements (specified by
   * numObjectsToShow) of a certain class (specified by classToFilter)
   * upon initialization, and toggles on those items when the
   * toggleSwitch is clicked. Upon displaying on toggle, this class also
   * shows a specified container class container pagination.
   *
   * Example usage:
   *  var showHidePanel = new M.Community.View.Util.ShowHide({
   *    numObjectsToShow: 3,
   *    classToFilter: 'myClass',
   *    expandText: 'see more of myClass',
   *    collapseText: 'hide some of myClass'
   *    pageClass: 'myPagination', // this class will be hidden by default
   *    itemsParentPanelEl: $someElement // where the show/hide objects are in
   *    shouldToggleHeader: true // shows the header upon expansion
   *  });
   *  showHidePanel.$el.insertAfter($someElement);
   *
   */
  M.Community.View.Util.ShowHide = Backbone.View.extend({
    className: 'showHidePanel',
    template: M.Template.Community.Util.ShowHide,

    options: {
      showExpanded: false,
      saveExpandSettingToLocalStorage: false,
      localStorageExpandKey: '',
      expandText: 'show more',
      collapseText: 'show less'
    },

    events: {
      'click .toggleSwitch': '_toggle'
    },

    initialize: function() {
      M.required(this.options.numObjectsToShow);
      M.required(this.options.classToFilter);
      M.required(this.options.itemsParentPanelEl);
      this.$el = $(this.el);
      this.$itemsParentPanelEl = this.options.itemsParentPanelEl;
      this.filterClass = '.' + this.options.classToFilter;

      this.render();
    },

    render: function() {
      // If we have fewer or exactly enough objects, we don't need a show/hide button
      if (this.getAllFilterObjects().length <= this.options.numObjectsToShow) {
        return this;
      }

      this.$el.html(this.template());
      this.$el.show();

      // Check if we're using localstorage to track the expand/collapse status
      // for this widget and if the value is set to true for expanded
      var showExpandedByLocalStorage =
        this.options.saveExpandSettingToLocalStorage &&
        M.localStorageManager.get(this.options.localStorageExpandKey);

      if (this.options.showExpanded || showExpandedByLocalStorage) {
        this._onExpand();
      } else {
        this._onCollapse();
      }
      return this;
    },

    getAllFilterObjects: function() {
      return this.$itemsParentPanelEl.find(this.filterClass);
    },

    getVisibleFilterObjects: function() {
      return this.$itemsParentPanelEl.find(this.filterClass).filter(function(){
        return $(this).css('display') !== 'none';
      });
    },

    getPagerElements: function() {
      return this.$itemsParentPanelEl.find('.' + this.options.pageClass);
    },

    _hideVisible: function() {
      /**
       * only show the first numObjectsToShow of numVisibleObjects
       * loop through all visibleObjects and only hide the last few of
       * them to show the appropriate number of elements.
       */
      var numObjectsToShow = this.options.numObjectsToShow;
      var visibleObjects = this.getVisibleFilterObjects();
      var numVisibleObjects = visibleObjects.length;
      var index = numVisibleObjects - 1;
      while (numVisibleObjects > numObjectsToShow) {
        var thisObjectToFilter = $(visibleObjects)[index];
        $(thisObjectToFilter).hide();
        numVisibleObjects--;
        index--;
      }
      this.getPagerElements().hide();
      this.isHidden = true;
      return this;
    },

    _toggle: function(evt) {
      var that = this;
      if (this.isHidden === true) {
        this.getAllFilterObjects().show(500, "linear");
        this.getPagerElements().show();
        this._onExpand();
      } else {
        var parentPanelEl = this.$itemsParentPanelEl[0];
        // Scroll to top of container after collapsing
        $('html, body').animate({
          scrollTop: $(parentPanelEl).position().top
        }, 500, "easeInOutExpo", function() {
          that._onCollapse();
        });
      }
      return false;
    },

    _onExpand: function() {
      var toggleSwitch = this.$el.find('.toggleSwitch');
      toggleSwitch.text(this.options.collapseText);
      this.isHidden = false;
      if (this.options.saveExpandSettingToLocalStorage) {
        M.localStorageManager.set(this.options.localStorageExpandKey, true);
      }
      if (this.options.shouldToggleHeader === true) {
        this.$itemsParentPanelEl.find('.panelHeader').show();
      }
    },

    _onCollapse: function() {
      var toggleSwitch = this.$el.find('.toggleSwitch');
      toggleSwitch.text(this.options.expandText);
      if (this.options.saveExpandSettingToLocalStorage) {
        M.localStorageManager.set(this.options.localStorageExpandKey, false);
      }
      if (this.options.shouldToggleHeader === true) {
        this.$itemsParentPanelEl.find('.panelHeader').hide();
      }
      this._hideVisible();
    }

  });

  return {
  };

});
